import { render, staticRenderFns } from "./MatterUpgrades.vue?vue&type=template&id=2802ce26&scoped=true&"
import script from "./MatterUpgrades.vue?vue&type=script&lang=js&"
export * from "./MatterUpgrades.vue?vue&type=script&lang=js&"
import style0 from "./MatterUpgrades.vue?vue&type=style&index=0&id=2802ce26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802ce26",
  null
  
)

export default component.exports